export default "__VITE_PUBLIC_ASSET__d53294f3__"